export const SET_MODULES = 'SET_MODULES';
export const SET_MODULE = 'SET_MODULE';
export const ADD_MODULE = 'ADD_MODULE';
export const UPDATE_MODULE = 'UPDATE_MODULE';
export const REMOVE_MODULE = 'REMOVE_MODULE';
export const CLEAR_MODULE = 'CLEAR_MODULE';
export const CLEAR_MODULES = 'CLEAR_MODULES';
